import '../scss/form.scss';

import naja from 'naja';
import netteForms from 'nette-forms';
import Form from './components/Form';
import LoadingIndicatorExtension from "./components/naja/LoadingIndicatorExtension";
// import InvisibleRecaptcha from "./components/InvisibleRecaptcha";
import Filter from "./components/Filter";
import PaginationScroll from "./components/PaginationScroll";
import OrderPerson from "./components/OrderPerson";
import Flashes from "./components/Flashes";

window.Nette = netteForms;

document.addEventListener('DOMContentLoaded', naja.initialize.bind(naja));
netteForms.initOnLoad();

window.addEventListener('DOMContentLoaded', (event) => {
    naja.registerExtension(new LoadingIndicatorExtension('#globalLoadingIndicator'));
    Form.init();
    Form.handleChecked();
    Form.handleFixedLabel();
    // InvisibleRecaptcha.init();
    Filter.init();
    PaginationScroll.init();
    Flashes.init();
    OrderPerson.init();
});
